import React from 'react';

const CustomLegend = ({ payload, labelMapping = {}, colorKey = 'color' }) => {
    if (!payload || payload.length === 0) return null;

    return (
        <div>
            <ul
                style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'flex',
                    columnGap: '0.5rem',
                    rowGap: '0.125rem',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    marginTop: '1rem',
                }}
            >
                {payload.map((entry, index) => (
                    <li
                        key={`legend-item-${index}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 4,
                            textTransform: 'capitalize',
                        }}
                    >
                        <span
                            style={{
                                display: 'inline-block',
                                width: 12,
                                height: 12,
                                backgroundColor: entry[colorKey],
                                marginRight: 8,
                                borderRadius: 2,
                            }}
                        />
                        <span style={{ fontSize: 12 }}>
                            {labelMapping[entry.value] || entry.value}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CustomLegend;